module.exports = __webpack_public_path__ + "static/media/products-redline.9f4a3dd6.svg";